import { isArray } from "lodash";
import { ListResponse } from "src/types";
import { showErrorToast } from "src/ui/shared/toasts/Toasts";

import HttpService from "./httpService";
import RouteService from "./routeService";

const getCountriesList = async () => {
    try {
        const endpoint = await RouteService.getAccountsRoute();
        const { data } = await HttpService.get<ListResponse<API.Country>>(endpoint + "locations");
        return data.list;
    } catch (_error) {
        showErrorToast("Failed loading countries list");
    }
};

export const getCountryData = async () => {
    const countries = await getCountriesList();

    if (!isArray(countries)) {
        return {
            phoneCodes: [],
            countryList: [],
            mossCountries: [],
        };
    }

    const phoneCodes = countries.map((country) => ({
        value: country.phone,
        label: `${country.country} (${country.phone})`,
    }));

    const countryList = countries.map((country) => ({
        value: country.country,
        label: country.country,
    }));

    const mossCountries = countries.filter((country) => country.usesMOSS).map((country) => country.country);

    return {
        phoneCodes,
        countryList,
        mossCountries,
    };
};
